import { LegacyBootstrapService } from '~/legacy-bootstrap.service';

export const LEGACY_PROVIDERS = [
  {
    deps: ['$injector'],
    provide: 'ToastService',
    useFactory: ($injector: any) => $injector.get('ToastService'),
  },
  {
    deps: ['$injector'],
    provide: 'ModeCollection',
    useFactory: ($injector: any) => $injector.get('ModeCollection'),
  },
  {
    deps: ['$injector'],
    provide: 'ReportModel',
    useFactory: ($injector: any) => $injector.get('ReportModel'),
  },
  {
    deps: ['$injector'],
    provide: '$urlService',
    useFactory: ($injector: any) => $injector.get('$urlService'),
  },
  {
    deps: ['$injector'],
    provide: '$transitions',
    useFactory: ($injector: any) => $injector.get('$transitions'),
  },
  {
    deps: ['$injector'],
    provide: '$state',
    useFactory: ($injector: any) => $injector.get('$state'),
  },
  LegacyBootstrapService,
];
